// extracted by mini-css-extract-plugin
export default {"button":"RegisterForm_button__G+Hyo","checkbox":"RegisterForm_checkbox__TLGIa"};